import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_page: 1,
  page_size: 10,
  has_more: false,
  total_page: 0,
  total_count: 0,
  data: [],
  filters: {},
};

export const helpSlice = createSlice({
  name: "helpReducer",
  initialState,
  reducers: {
    setHelpList: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { setHelpList } = helpSlice.actions;

export default helpSlice.reducer;
